export default __webpack_public_path__ + "static/media/notesApp.edecb737.png";